import Axios from "axios";
import { getParentUrl } from "../../utils/helpers";
import { cleanDuplicateSlash } from "../../plugins/fetch";
import { getApiBaseUrl } from "../../config";

// // const ssoDetailsURL =
// //   "https://wmaster-staging.wolkenservicedesk.com/company/getCompanySsoDetails"; //staging link

// // const ssoDetailsURL =
// //   "https://wmaster.wolkenservicedesk.com/company/getCompanySsoDetails"; //prod link

// // process.env.WMASTER_URL ||

// // const config = {
// //   "https://internalsupport.wolkenservicedesk.com":
// //     "https://api-internalsupport.wolkenservicedesk.com/",
// // };

// // const getApiBaseUrl = (domain) => {
// //   return config[domain];
// // };

function getAPIBase() {
  return `${getApiBaseUrl()}conductor-api/api/`;
}

export const getSSODetails = (domain) => {
  const formData = new FormData();
  const domainData = JSON.stringify({
    // domain: "internalsupport.wolkenservicedesk.com",
    domain,
  });
  formData.append("data", domainData);

  return Axios.post(
    `${process.env.REACT_APP_WMASTER_URL}/company/getCompanySsoDetails`,
    formData,
    {
      headers: {
        authorization: "Basic Y1VyeWF0ZUlrU2U6YnVzdFRlV29sa2Vu",
      },
    }
  );
};

export const getValidSession = (url, hostName) => {
  const sessionUrl = url + "account_service/issessionvalid";

  return Axios.get(sessionUrl, {
    headers: {
      domain: hostName,
    },
    withCredentials: true,
  });
};

export const getTasksListing = () => {
  const domain = getParentUrl() || "";

  return Axios.get(`${getAPIBase()}wolkenWorkflow/tasks`, {
    headers: {
      domain,
    },
    withCredentials: true,
  });
};

export const getTaskInputs = (customTaskName) => {
  const domain = getParentUrl() || "";

  return Axios.get(`${getAPIBase()}customTasks/${customTaskName}/inputFields`, {
    headers: {
      domain,
    },
    withCredentials: true,
  });
};

export const getWorkflowBasedOnRequestID = (requestID) => {
  const domain = getParentUrl() || "";

  const cleanPath = cleanDuplicateSlash(
    `${getApiBaseUrl()}conductor-api/oauth/api/wolkenWorkflow/${requestID}`
  );

  return Axios.get(cleanPath, {
    headers: {
      domain,
    },
    withCredentials: true,
  });
};

export const getTabsList = () => {

  const domain = getParentUrl() || "";


  const cleanPath = cleanDuplicateSlash(
    `${getApiBaseUrl()}conductor-api/api/tabs/tablist`
  );

  // return Axios.get(cleanPath, {
  //   headers: {
  //     domain,
  //   },
  //   withCredentials: true,
  // });



  // return Axios.get(cleanPath, {
  //   headers: {
  //     domain,
  //   },
  //   withCredentials: true,
  // });

  var result = Axios.get(cleanPath, {
    headers: {
      domain,
    },
    withCredentials: true,
  });

  return result;
};

export const pullApiDetails = (payload) => {
  const domain = getParentUrl() || "";

  const cleanPath = cleanDuplicateSlash(
    `${getApiBaseUrl()}wlkn-reports/ext_data_push/pull`
  );

  return Axios.post(cleanPath, payload, {
    headers: {
      // domain: "internalsupport.wolkenservicedesk.com",
      domain,
    },
    withCredentials: true,
  });
};
export const getSubStatusIds = (statusId) => {
  const domain = getParentUrl() || "";

  return Axios.get(`${getAPIBase()}customTasks/subStatus/${statusId}`, {
    headers: {
      domain,
    },
    withCredentials: true,
  });
};

export const getCategories = () => {
  const domain = getParentUrl() || "";
  const cleanPath = cleanDuplicateSlash(
    `${getApiBaseUrl()}conductor-api/oauth/api/wolkenWorkflow/categories`
    ///conductor-api/oauth/api/wolkenWorkflow/categories
    ///conductor-api/oauth/api/wolkenWorkflow/getAllCategories
  );

  return Axios.get(
    `${getAPIBase()}wolkenWorkflow/categories`,
    // cleanPath
    {
      headers: {
        domain,
      },
      withCredentials: true,
    }
  );
};

export const deleteWorkflowApi = (name, version) => {
  const domain = getParentUrl() || "";
  return Axios.delete(`${getAPIBase()}metadata/workflow/${name}/${version}`, {
    headers: {
      domain,
    },
    withCredentials: true,
  });
};

export const deleteEntireWorkflowApi = (name) => {
  const formData = new FormData();
  const domain = getParentUrl() || "";
  formData.append("workflowName", name);
  return Axios.post(`${getAPIBase()}wolkenWorkflow/delete_workflow`, formData, {
    headers: {
      domain,
      "Content-Type": "application/json",
    },
    withCredentials: true,
  });
};

export function uploadImage(api, input, httpType = "POST") {
  api = getAPIBase() + api;
  switch (httpType) {
    case "GET":
      return Axios.get(api, input);
    default:
      return Axios.post(api, input);
  }
}

export function fetchPresignedUrl(formData) {
  return Axios.post(`${getAPIBase()}attachment/preverify_attachment`, formData);
}

export const getCssDetails = () => {
  const domain = getParentUrl() || "";
  return Axios.get(`${getApiBaseUrl()}/nau/portal/cssdetails`, {
    headers: {
      domain,
    },
    withCredentials: true,
  }).catch((err) => {
    console.log(err);
  });
};
